import { useCallback, useEffect, useRef, useState } from 'react';
import { Helmet } from 'react-helmet-async';
// @mui
import {
    Card,
    Container,
    IconButton,
    MenuItem,
    Popover,
    Stack,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableRow,
    Typography,
} from '@mui/material';
// components
import Iconify from '../components/iconify';
import Scrollbar from '../components/scrollbar';
// sections
// mock
import debounce from 'lodash/debounce';
import { ButtonGroup } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router-dom';
import { toast } from 'react-toastify';
import Breadcrumb from 'src/components/Breadcrumb/Breadcrumb';
import AddButton from 'src/components/Button.js/AddBotton';
import TableListHead from 'src/components/Table/TableListHead';
import Loader from 'src/components/loader/loader';
import ConfigDeviceModal from 'src/components/modal/ConfigDeviceModal';
import ConfirmLockModal from 'src/components/modal/ConfirmLockModal';
import ConfirmModal from 'src/components/modal/ConfirmModal';
import ConfirmSyncListUser from 'src/components/modal/ConfirmSyncListUser';
import ConfirmUpdateDeltaTime from 'src/components/modal/ConfirmUpdateDeltaTime';
import { sendRequest, serviceList } from 'src/utils';
import { KeysConfigDevice } from 'src/utils/keys';
import TableListToolbar from '../components/Table/TableListToolbar';
import Label from '../components/label';

// ----------------------------------------------------------------------

// ----------------------------------------------------------------------

function descendingComparator(a, b, orderBy) {
    if (b[orderBy] < a[orderBy]) {
        return -1;
    }
    if (b[orderBy] > a[orderBy]) {
        return 1;
    }
    return 0;
}

// function getComparator(order, orderBy) {
//     return order === 'desc'
//         ? (a, b) => descendingComparator(a, b, orderBy)
//         : (a, b) => -descendingComparator(a, b, orderBy);
// }

// function applySortFilter(array, comparator, query) {
//     const stabilizedThis = array.map((el, index) => [el, index]);
//     stabilizedThis.sort((a, b) => {
//         const order = comparator(a[0], b[0]);
//         if (order !== 0) return order;
//         return a[1] - b[1];
//     });
//     if (query) {
//         return filter(array, (_user) => _user.name.toLowerCase().indexOf(query.toLowerCase()) !== -1);
//     }
//     return stabilizedThis.map((el) => el[0]);
// }

export default function ListConfigDevice() {
    const params = useParams();
    const [open, setOpen] = useState(null);
    const [visibleDel, setVisibleDel] = useState(false);
    const arrFillters = useRef([]);
    const { t } = useTranslation();
    const [getFlags, setGetFlags] = useState(false);
    const isEdit = useRef(false);
    const [tableData, setTableData] = useState([]);
    const delFlags = useRef(false);
    const [deleleFlags, setDeleleFlags] = useState(false);

    const [dataAction, setDataAction] = useState({});
    const [order, setOrder] = useState('asc');

    const [visible, setVisible] = useState(false);

    const [selected, setSelected] = useState([]);

    const [orderBy, setOrderBy] = useState('name');

    const [configDevice, setConfigDevice] = useState({});

    const getRef = useRef(false);
    const tableRef = useRef(null);

    const searchValueDeboun = useRef('');
    const throttled = useRef(debounce(() => getData(), 1000));
    const Keys = KeysConfigDevice;
    const [visibleLock, setVisibleLock] = useState(false);
    const lock = useRef(false);
    const [lockFlags, setLockFlags] = useState(false);

    const [visibleUpdateDeltaTime, setVisibleUpdateDeltaTime] = useState(false);
    const updateDeltaTimeRef = useRef(false);
    const [updateDeltaTimeFlags, setUpdateDeltaTimeFlags] = useState(false);

    const [visibleSyncListUser, setVisibleSyncListUser] = useState(false);
    const syncListUserRef = useRef(false);
    const [syncListUserFlags, setSyncListUserFlags] = useState(false);

    // const { onDownload } = useDownloadExcel({
    //     currentTableRef: tableRef.current,
    //     filename: t('quan_ly_bo_phan'),
    //     sheet: t('quan_ly_bo_phan'),
    // });

    const TABLE_HEAD = [
        { id: 'serial_no', label: t('serial_no'), alignRight: false },
        // { id: 'code_cabinet', label: t('code_cabinet'), alignRight: false },
        { id: 'name_cabinet', label: t('name_cabinet'), alignRight: false },
        { id: 'ipadd_device', label: t('ip_add_device'), alignRight: false },
        { id: 'account', label: t('account'), alignRight: false },
        // { id: 'password', label: t('password'), alignRight: false },
        { id: 'portno_device', label: t('portno_device'), alignRight: false },
        { id: 'delta_time', label: t('delta_time'), alignRight: false },
        { id: 'note', label: t('note_'), alignRight: false },
        { id: 'active_yn', label: t('status'), alignRight: false },
        { id: 'status_sync_hik', label: t('status_sync_hik'), alignRight: false },
        { id: 'is online', label: t('online_devices_info'), alignRight: false },
        { id: 'Thao tác', label: '', alignRight: false },
    ];

    useEffect(() => {
        setTimeout(() => {
            getData();
        }, 600);
    }, []);

    const getData = useCallback(() => {
        if (getRef.current) {
            return;
        }
        getRef.current = true;
        const InVal = [999999999, searchValueDeboun.current, +params.idPermission];
        sendRequest(serviceList.getAllConfigDevice, InVal, getDataResult, true, timeOutFunct, 40000);
    }, []);

    const getDataResult = (reqInfoMap, message) => {
        getRef.current = false;
        setGetFlags(false);
        if ((message['proc_status']?.toString() || '0') === '0') {
            toast.error('Error: ' + message['proc_message']);
            return;
        } else {
            setTableData(message.proc_data.rows[0].o_1[0]);
            arrFillters.current = message.proc_data.rows;
            setConfigDevice(message.proc_data.rows[0].o_2[0][0]);
        }
    };

    const timeOutFunct = (reqInfo) => {
        getRef.current = false;
        setGetFlags(false);
        toast.error(t('error.time_out'));
    };

    const handleCloseMenu = () => {
        setOpen(null);
    };

    const handleRequestSort = (event, property) => {
        const isAsc = orderBy === property && order === 'asc';
        setOrder(isAsc ? 'desc' : 'asc');
        setOrderBy(property);
    };

    const handleSelectAllClick = (event) => {
        if (event.target.checked) {
            const newSelecteds = tableData.map((n) => n.supplier_nm);
            setSelected(newSelecteds);
            return;
        }
        setSelected([]);
    };

    const handleDelete = () => {
        if (!dataAction[Keys.id]) return toast.error(t('error.system_error'));
        if (delFlags.current) {
            return;
        }
        setDeleleFlags(true);
        delFlags.current = true;
        const InVal = [dataAction[Keys.id]];
        sendRequest(serviceList.deleteConfigDevice, InVal, deleteResult, true, timeOutFunctDel, 40000);
    };

    const deleteResult = (reqInfoMap, message) => {
        setDeleleFlags(false);
        delFlags.current = false;
        if ((message['proc_status']?.toString() || '0') === '0') {
            toast.error('Error: ' + message['proc_message']);
            setVisibleDel(false);
            return;
        } else {
            toast.success(message['proc_message']);
            setVisibleDel(false);
            getData();
        }
    };

    const timeOutFunctDel = (reqInfo) => {
        setDeleleFlags(false);
        delFlags.current = false;
        toast.error(t('error.time_out'));
    };

    const handleLock = () => {
        if (!dataAction[Keys.id]) return toast.error(t('error.system_error'));
        if (lock.current) {
            return;
        }
        setLockFlags(true);
        lock.current = true;
        const InVal = [dataAction[Keys.id], dataAction[Keys.active_yn] === '1' ? '0' : '1'];
        sendRequest(serviceList.updateActiveConfigDevice, InVal, deviceLockResult, true, timeOutFunctDeviceLock, 40000);
    };

    const deviceLockResult = (reqInfoMap, message) => {
        setLockFlags(false);
        lock.current = false;
        if ((message['proc_status']?.toString() || '0') === '0') {
            toast.error('Error: ' + message['proc_message']);
            setVisibleLock(false);
            return;
        } else {
            toast.success(message['proc_message']);
            setVisibleLock(false);
            getData();
        }
    };

    const timeOutFunctDeviceLock = (reqInfo) => {
        setLockFlags(false);
        lock.current = false;
        toast.error(t('error.time_out'));
    };

    const handleUpdateDeltaTime = () => {
        if (!dataAction[Keys.cabinet_id]) return toast.error(t('error.system_error'));
        if (updateDeltaTimeRef.current) {
            return;
        }
        setUpdateDeltaTimeFlags(true);
        updateDeltaTimeRef.current = true;
        const InVal = [dataAction[Keys.cabinet_id]];
        sendRequest(
            serviceList.updateDeltaTime,
            InVal,
            updateDeltaTimeResult,
            true,
            timeOutFunctUpdateDeltaTime,
            40000
        );
    };

    const updateDeltaTimeResult = (reqInfoMap, message) => {
        setUpdateDeltaTimeFlags(false);
        updateDeltaTimeRef.current = false;
        if ((message['proc_status']?.toString() || '0') === '0') {
            toast.error('Error: ' + message['proc_message']);
            setVisibleUpdateDeltaTime(false);
            return;
        } else {
            toast.success(message['proc_message']);
            setVisibleUpdateDeltaTime(false);
            getData();
        }
    };

    const timeOutFunctUpdateDeltaTime = (reqInfo) => {
        setUpdateDeltaTimeFlags(false);
        updateDeltaTimeRef.current = false;
        toast.error(t('error.time_out'));
    };

    const searchValue = (value) => {
        if (!value) {
            value = '';
        }
        searchValueDeboun.current = value;
        // setvalueSearch(value);
        throttled.current();
    };

    const handleSyncListUser = () => {
        if (!dataAction[Keys.id]) return toast.error(t('error.system_error'));
        if (syncListUserRef.current) {
            return;
        }
        setSyncListUserFlags(true);
        syncListUserRef.current = true;
        const InVal = [dataAction[Keys.id]];
        sendRequest(serviceList.syncDataUsers, InVal, syncListUserResult, true, timeOutFunctSyncListUserResult, 45000);
        setVisibleSyncListUser(false);
        getData();
    };

    const syncListUserResult = (reqInfoMap, message) => {
        setSyncListUserFlags(false);
        syncListUserRef.current = false;
        if ((message['proc_status']?.toString() || '0') === '0') {
            toast.error('Error: ' + message['proc_message']);
            // setVisibleSyncListUser(false);
            getData();
            return;
        } else {
            // toast.success(message['proc_message']);
            // setVisibleSyncListUser(false);
            getData();
        }
    };

    const timeOutFunctSyncListUserResult = (reqInfo) => {
        setSyncListUserFlags(false);
        syncListUserRef.current = false;
        // toast.error(t('error.time_out'));
        getData();
    };

    return (
        <>
            <Helmet>
                <title> {t('config_device_list')} </title>
            </Helmet>

            <Container>
                <ConfigDeviceModal
                    fuctGet={getData}
                    idPermission={params.idPermission}
                    setVisible={setVisible}
                    visible={visible}
                    isEdit={isEdit.current}
                    dataUpdate={dataAction}
                />
                <Stack direction="row" alignItems="center" justifyContent="space-between" mb={1}>
                    <Typography variant="h4" gutterBottom>
                        {t('config_device_list')}
                    </Typography>
                    {/* <Button variant="contained" startIcon={<Iconify icon="ei:share-apple" />} onClick={onDownload}>
                        {t('export_excel')}
                    </Button> */}
                </Stack>{' '}
                <Breadcrumb
                    paths={[
                        {
                            label: t('quan_ly_tu'),
                            url: `/home/manager-cabinet/${params.idPermission}`,
                            navigate: false,
                        },
                        { label: t('config_device_list'), url: '#', navigate: false },
                    ]}
                />
                <Loader loading={getFlags} />
                <Card>
                    <TableListToolbar getValue={searchValue} />
                    <ConfirmModal visible={visibleDel} setVisible={setVisibleDel} handleDelete={handleDelete} />
                    <ConfirmLockModal
                        visible={visibleLock}
                        setVisible={setVisibleLock}
                        loading={lockFlags}
                        handleSave={handleLock}
                    />
                    <ConfirmUpdateDeltaTime
                        visible={visibleUpdateDeltaTime}
                        setVisible={setVisibleUpdateDeltaTime}
                        loading={updateDeltaTimeFlags}
                        handleSave={handleUpdateDeltaTime}
                    />

                    <ConfirmSyncListUser
                        visible={visibleSyncListUser}
                        setVisible={setVisibleSyncListUser}
                        loading={syncListUserFlags}
                        handleSave={handleSyncListUser}
                        data={dataAction}
                    />

                    <Scrollbar>
                        <TableContainer sx={{}}>
                            <Table ref={tableRef}>
                                <TableListHead
                                    order={order}
                                    orderBy={orderBy}
                                    headLabel={TABLE_HEAD}
                                    rowCount={tableData.length}
                                    numSelected={selected.length}
                                    onRequestSort={handleRequestSort}
                                    onSelectAllClick={handleSelectAllClick}
                                />
                                <TableBody>
                                    {tableData.length > 0 &&
                                        tableData.map((item) => {
                                            return (
                                                <TableRow
                                                    hover
                                                    key={item[Keys.id]}
                                                    tabIndex={-1}
                                                    role="checkbox"
                                                    // selected={selectedUser}
                                                >
                                                    <TableCell padding="checkbox"></TableCell>

                                                    <TableCell align="left">{item[Keys.serial_no]}</TableCell>
                                                    {/* <TableCell align="left">{item[Keys.cabinet_cd]}</TableCell> */}
                                                    <TableCell align="left">{item[Keys.cabinet_nm]}</TableCell>
                                                    <TableCell align="left">
                                                        <a
                                                            href={`${item[Keys.ipadd_device]}:${
                                                                item[Keys.portno_device]
                                                            }`}
                                                            target="_blank"
                                                        >
                                                            {item[Keys.ipadd_device]}
                                                        </a>
                                                    </TableCell>
                                                    <TableCell align="left">{item[Keys.account]}</TableCell>
                                                    {/* <TableCell align="left">{item[Keys.password]}</TableCell> */}
                                                    <TableCell align="right">{item[Keys.portno_device]}</TableCell>
                                                    <TableCell align="left">{item[Keys.delta_time]}s</TableCell>
                                                    <TableCell align="left">{item[Keys.note]}</TableCell>
                                                    <TableCell align="left">
                                                        <Label
                                                            color={
                                                                (item[Keys.active_yn] === '0' && 'error') || 'primary'
                                                            }
                                                        >
                                                            {item[Keys.active_yn] === '1' ? t('active') : t('band')}
                                                        </Label>
                                                    </TableCell>
                                                    <TableCell align="left">
                                                        {item[Keys.status_key_sync_hikvision] === null ? (
                                                            ''
                                                        ) : (
                                                            <Label
                                                                color={
                                                                    (item[Keys.status_key_sync_hikvision] === 's01' &&
                                                                        'warning') ||
                                                                    (item[Keys.status_key_sync_hikvision] === 's02' &&
                                                                        'error') ||
                                                                    (item[Keys.status_key_sync_hikvision] === 's03' &&
                                                                        'primary') ||
                                                                    'primary'
                                                                }
                                                            >
                                                                {item[Keys.status_sync_hikvision]}
                                                            </Label>
                                                        )}
                                                    </TableCell>
                                                    <TableCell align="left">
                                                        {item[Keys.is_online] === null ? (
                                                            ''
                                                        ) : (
                                                            <Label
                                                                color={
                                                                    item[Keys.is_online] === '1' ? 'success' : 'error'
                                                                }
                                                            >
                                                                {item[Keys.is_online] === '1'
                                                                    ? t('is_online')
                                                                    : t('not_online')}
                                                            </Label>
                                                        )}
                                                    </TableCell>
                                                    {/* <TableCell align="left">
                                                        {glb_sv.convertMultipleLanguages(item.group_nm)}
                                                    </TableCell> */}

                                                    <TableCell align="right" style={{ maxWidth: '250px' }}>
                                                        <ButtonGroup
                                                            variant="text"
                                                            aria-label="text button group"
                                                            style={{ display: 'flex', justifyContent: 'flex-start' }}
                                                        >
                                                            {' '}
                                                            <IconButton
                                                                size="large"
                                                                color={
                                                                    (item[Keys.active_yn] === '0' && 'error') ||
                                                                    'primary'
                                                                }
                                                                onClick={() => {
                                                                    setDataAction(item);
                                                                    setVisibleLock(true);
                                                                }}
                                                            >
                                                                <Iconify
                                                                    icon={
                                                                        item[Keys.active_yn] !== '1'
                                                                            ? 'material-symbols:lock'
                                                                            : 'material-symbols:lock-open'
                                                                    }
                                                                />
                                                            </IconButton>
                                                            <IconButton
                                                                size="large"
                                                                color={'primary'}
                                                                onClick={() => {
                                                                    setDataAction(item);
                                                                    setVisibleUpdateDeltaTime(true);
                                                                }}
                                                            >
                                                                <Iconify icon={'mdi:timer-sync-outline'} />
                                                            </IconButton>
                                                            <IconButton
                                                                size="large"
                                                                color={'primary'}
                                                                onClick={() => {
                                                                    setDataAction(item);
                                                                    setVisibleSyncListUser(true);
                                                                }}
                                                            >
                                                                <Iconify icon={'mdi:sync'} />
                                                            </IconButton>
                                                            {/* {configDevice?.update === '1' && ( */}
                                                            <IconButton
                                                                size="large"
                                                                color={'warning'}
                                                                onClick={() => {
                                                                    setDataAction(item);
                                                                    isEdit.current = true;
                                                                    setVisible(true);
                                                                }}
                                                            >
                                                                <Iconify icon={'eva:edit-fill'} />
                                                            </IconButton>
                                                            {/* // )}{' '} */}
                                                            {/* {configDevice?.delete === '1' && ( */}
                                                            <IconButton
                                                                size="large"
                                                                color={'error'}
                                                                onClick={() => {
                                                                    setDataAction(item);
                                                                    setVisibleDel(true);
                                                                }}
                                                            >
                                                                <Iconify icon={'eva:trash-2-outline'} />
                                                            </IconButton>
                                                            {/* // )} */}
                                                        </ButtonGroup>
                                                    </TableCell>
                                                </TableRow>
                                            );
                                        })}
                                </TableBody>
                            </Table>
                        </TableContainer>
                    </Scrollbar>
                </Card>
            </Container>

            <Popover
                open={Boolean(open)}
                anchorEl={open}
                onClose={handleCloseMenu}
                anchorOrigin={{ vertical: 'top', horizontal: 'left' }}
                transformOrigin={{ vertical: 'top', horizontal: 'right' }}
                PaperProps={{
                    sx: {
                        p: 1,
                        width: 140,
                        '& .MuiMenuItem-root': {
                            px: 1,
                            typography: 'body2',
                            borderRadius: 0.75,
                        },
                    },
                }}
            >
                <MenuItem>
                    <Iconify
                        icon={'eva:edit-fill'}
                        sx={{ mr: 2 }}
                        onClick={() => {
                            isEdit.current = true;
                            setVisible(true);
                        }}
                    />
                    Edit
                </MenuItem>

                <MenuItem sx={{ color: 'error.main' }}>
                    <Iconify icon={'eva:trash-2-outline'} sx={{ mr: 2 }} />
                    Delete
                </MenuItem>
            </Popover>

            {/* {configDevice?.insert === '1' && ( */}
            <AddButton
                onClick={() => {
                    isEdit.current = false;
                    setVisible(true);
                    setDataAction({});
                }}
            />
            {/* )} */}
        </>
    );
}
